const ProgressBarForCard = ({ completed, total }) => {
  return (
    <div className="relative h-2 bg-sky-200 border-solid border-1 border-gray-500">
      <div
        className="absolute top-0 left-0 h-full bg-sky-500"
        style={{ width: `${(100 * completed) / total}%` }}
      ></div>
    </div>
  );
};

export default ProgressBarForCard;
